import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import type { GSCDailyMetrics } from '@ongrid/shared';

interface HistoryChartProps {
  data: GSCDailyMetrics[];
}

export function HistoryChart({ data }: HistoryChartProps) {
  // Sort by date ascending and format for chart
  const chartData = [...data]
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((d) => ({
      date: d.date,
      clicks: d.clicks,
      impressions: d.impressions,
      position: d.avg_position ? Math.round(d.avg_position * 10) / 10 : null,
    }));

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-[var(--text-muted)]">
        No historical data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#2a2a2a" />
        <XAxis
          dataKey="date"
          stroke="#6b6b6b"
          tick={{ fill: '#6b6b6b', fontSize: 11 }}
          tickFormatter={(date) => {
            const d = new Date(date);
            return `${d.getMonth() + 1}/${d.getDate()}`;
          }}
        />
        <YAxis
          yAxisId="left"
          stroke="#6b6b6b"
          tick={{ fill: '#6b6b6b', fontSize: 11 }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          stroke="#6b6b6b"
          tick={{ fill: '#6b6b6b', fontSize: 11 }}
          reversed
          domain={[1, 'auto']}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#1f1f1f',
            border: '1px solid #2a2a2a',
            borderRadius: '8px',
            color: '#fafafa',
          }}
        />
        <Legend
          verticalAlign="top"
          height={36}
          formatter={(value) => (
            <span style={{ color: '#a1a1a1', fontSize: '12px' }}>{value}</span>
          )}
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="clicks"
          stroke="#22c55e"
          strokeWidth={2}
          dot={false}
          name="Clicks"
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="impressions"
          stroke="#3b82f6"
          strokeWidth={2}
          dot={false}
          name="Impressions"
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="position"
          stroke="#f97316"
          strokeWidth={2}
          dot={false}
          name="Position"
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

